import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { useState } from 'react';

type CopyTextrops = {
  text: string;
  copyText: string;
};

const CopyText: React.FunctionComponent<CopyTextrops> = ({ text, copyText }) => {
  const [copyButtonStatus, setCopyButtonStatus] = useState(false);
  const handleCopyToClipboard = (text: string, type: 'ADDRESS' | 'MEMO') => {
    navigator.clipboard.writeText(text || '');
    setCopyButtonStatus(true);
    setTimeout(() => {
      setCopyButtonStatus(false);
    }, 2500);
  };
  return (
    <div className="copy-text-container">
      <input
        type="text"
        name="deposit-address"
        id="deposit-address"
        autoComplete="off"
        value={text}
        readOnly
      />
      {copyButtonStatus ? (
        <CheckOutlined className="icon-copy" width={20} />
      ) : (
        <CopyOutlined
          className="icon-copy"
          onClick={() => handleCopyToClipboard(copyText, 'ADDRESS')}
          width={20}
        />
      )}
    </div>
  );
};
export default CopyText;
